import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  REFERRAL_FAQ_ITEMS,
  REFERRAL_TERMS_SUMMARY,
} from '@app/pages/referrals-page/referrals-faq.content';

@Component({
  selector: 'referral-faq-section',
  templateUrl: './referral-faq-section.component.html',
  styleUrls: ['./referral-faq-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralFaqSectionComponent {
  faqItems = REFERRAL_FAQ_ITEMS;
  termsSummary = REFERRAL_TERMS_SUMMARY;

  expandedIndex: number | null = null;

  toggle(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  isExpanded(index: number) {
    return this.expandedIndex === index;
  }
}
